import { gql } from '@apollo/client';

export const GET_MNEMONICS_FULL_LIST = gql`
  query mnemonicsFullList(
    $orderBy: [MnemonicQueryResolver_List_SortingInputType!]
  ) {
    classifiers {
      mnemonic {
        list(
          paginate: { per_page: 100, page: 0 }
          where: {}
          order_by: $orderBy
        ) {
          items {
            id
            mnemonic
            mnemonic_rus
            group_name
            group_name_rus
          }
        }
      }
    }
  }
`;
